module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eb658c5b4ef96595e01fe460b9385934.png";